import { useState } from "react";
import PropTypes from "prop-types";
import Popover from "@mui/material/Popover";
import TableRow from "@mui/material/TableRow";
import MenuItem from "@mui/material/MenuItem";
import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { CircularProgress, Fade } from "@mui/material";
import Iconify from "../../components/iconify";
import EditHotelBrand from "./view/EditHotelBrand";
import DeleteHotel from "./view/DeleteHotel";
import { useDispatch } from "react-redux";
import { deleteHotelBrand, updateHotelBrand } from "../../features/dataAction";
import toast from "react-hot-toast";

// ----------------------------------------------------------------------

export default function HotelTableRow({ id, name, address, phone }) {
  const [open, setOpen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const dispatch = useDispatch();

  const handleEditSave = (updatedHotel) => {
    setLoading(true);
    dispatch(
      updateHotelBrand(updatedHotel, (error) => {
        setLoading(false);
        if (error) {
          toast.error(error);
        } else {
          setEditModalOpen(false);
          toast.success("Hotel brand updated successfully");
        }
      })
    );
  };

  const handleEditClick = () => {
    setSelectedHotel({ id, name, phone, address });
    setEditModalOpen(true);
    handleCloseMenu();
  };

  const handleDelete = () => {
    setLoading(true);
    dispatch(
      deleteHotelBrand(id, (error) => {
        setLoading(false);
        if (error) {
          toast.error(error);
        } else {
          setDeleteOpen(false);
          toast.success("Hotel brand deleted successfully");
        }
      })
    );
  };

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  if (loading) {
    return (
      <TableRow>
        <TableCell colSpan={7} align="center">
          <CircularProgress size={24} />
        </TableCell>
      </TableRow>
    );
  }

  return (
    <>
      <Fade in timeout={400}>
        <TableRow hover tabIndex={-1} role="checkbox">
          <TableCell>{id}</TableCell>
          <TableCell component="th" scope="row" padding="none">
            <Typography variant="subtitle2" noWrap>
              {name}
            </Typography>
          </TableCell>
          <TableCell>{address}</TableCell>
          <TableCell>{phone}</TableCell>
          <TableCell>
            <IconButton onClick={handleOpenMenu}>
              <Iconify icon="eva:more-vertical-fill" />
            </IconButton>
          </TableCell>
        </TableRow>
      </Fade>
      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: { width: 140 },
        }}
      >
        <MenuItem onClick={handleEditClick}>
          <Iconify icon="eva:edit-fill" sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem
          onClick={() => setDeleteOpen(true)}
          sx={{ color: "error.main" }}
        >
          <Iconify icon="eva:trash-2-outline" sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>

      {isEditModalOpen && (
        <EditHotelBrand
          open={isEditModalOpen}
          handleClose={() => {
            setEditModalOpen(false);
            setSelectedHotel(null);
          }}
          orderData={selectedHotel}
          handleSave={handleEditSave}
        />
      )}

      <DeleteHotel
        open={deleteOpen}
        handleClose={() => setDeleteOpen(false)}
        handleDelete={handleDelete}
      />
    </>
  );
}

HotelTableRow.propTypes = {
  id: PropTypes.any,
  address: PropTypes.any,
  phone: PropTypes.any,
  handleClick: PropTypes.func,
  adminUser: PropTypes.any,
  name: PropTypes.any,
};
